export default __webpack_public_path__ + "static/media/otvorko.e4588cfb.png";